import { Session } from '@ais-ui/auth';

export interface AutoCompleteDBShipInfo {
  callsign: string;
  imo: string;
  mmsi: string;
  shipname: string;
}

export const autocompleteDBShips = async (
  session: Session,
  searchString: string,
): Promise<AutoCompleteDBShipInfo[]> => {
  const response: AutoCompleteDBShipInfo[] = await session.request(
    'autocompleteShips',
    {
      searchType: 'AC_SHIPNAME',
      callsign: '',
      imo: '',
      mmsi: '',
      shipname: searchString,
    },
  );

  return response;
};
